import React from "react";
import { cn } from "@/lib/utils";

interface MemberLabelProps extends React.HTMLAttributes<HTMLSpanElement> {
  className?: string;
  children: React.ReactNode;
}

export const memberLabelClassName = "bg-[linear-gradient(131.10deg,_rgba(160,134,105,1)_2%,_rgba(85,58,32,1)_100%)] bg-clip-text text-transparent";
/**
 * MemberLabel 组件：用于显示带有渐变色和自定义字体的文本。
 * 字体、字号等可通过 className 传入，渐变色和字体样式默认应用。
 */
export function MemberLabel({ className, children, style }: MemberLabelProps) {
  return (
    <span
      className={cn(
        memberLabelClassName,
        className
      )}
      style={style}
    >
      {children}
    </span>
  );
} 